import React, { useState } from 'react'
import { Form } from 'reactstrap';
import { Dialog, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Button, ButtonGroup } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import MuiButton from '@material-ui/core/Button';
import Draggable from 'react-draggable';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Paper from '@material-ui/core/Paper';
import moment from "moment";
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import MaterialInputListCoup from '../../Shared/Css/MaterialsInput/MaterialsInput.module.css';

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function MaterialInputListEditDbClick(props) {
  const { addOrEdit } = props
  const [materialJajeDateTime, setMaterialJajeDateTime] = useState(props.materialInputListEditValue.ms_결재지급월) //대금지불월
  //const [materialJajeBugaGumack, setMaterialJajeBugaGumack] = useState(props.materialInputListEditValue.ms_세액)  //부가세
  const [materialJajeIpgoGigubGumack, setMaterialJajeIpgoGigubGumack] = useState(props.materialInputListEditValue.ms_결재지급금액) //결재금액
  const [materialJajeIpgoGumackQuantity] = useState(props.materialInputListEditValue.계산서) //자재입고금액
  const [materialGelje, setMaterialGelje] = useState(props.materialInputListEditValue.ms_결재유무) //결재유무
  const [materialJajeJigubDateTime, setMaterialJajeJigubDateTime] = useState(props.materialInputListEditValue.ms_결재지급일자) //결재지급일자
  const [materialJajeDescription, setMaterialJajeDescription] = useState(props.materialInputListEditValue.ms_자재설명 !== null ? props.materialInputListEditValue.ms_자재설명 : '' ) //기타기록사항

  const styleDialogTitle = {
    position: 'absolute',
    color: 'white',
    fontSize: '0.85rem',
    margin: 0,
    right: '0',
    float: 'center',
    zIndex: '10', //z-index 겹침부분인덱스 기본갑은 0 이다
  };

  //자재지급월
  let materialJajeDateTimeHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDateTime(e.target.value);
  };
  //결재금액
  let materialJajeIpgoGigubGumackHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpgoGigubGumack(e.target.value);
  };
  //결재유무
  let materialGeljeHandleHandle = (e) => {
    e.preventDefault();
    setMaterialGelje(e.target.value);
  };
  
  //결재금액/결재유무처리 +처리
  let materialJajeGuljaPlusHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpgoGigubGumack(materialJajeIpgoGumackQuantity);
    setMaterialGelje('결재');
    //setMaterialJajeJigubDateTime(moment().format('YYYY-MM-DD HH:mm'));
  };
  //결재금액/결재유무처리 -처리
  let materialJajeGuljaMinusHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpgoGigubGumack(props.materialInputListEditValue.ms_결재지급금액);
    setMaterialGelje(props.materialInputListEditValue.ms_결재유무);
    setMaterialJajeJigubDateTime(props.materialInputListEditValue.ms_결재지급일자);
  }
  //결재지급일자
  let materialJajeJigubDateTimeHandle = (e) => {
    e.preventDefault();
    setMaterialJajeJigubDateTime(e.target.value);
  };
  //기타기록사항
  let materialJajeDescriptionHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDescription(e.target.value);
  };
  //개행처리
  const materialJajeDescriptionKeyDownHandle = (e) => {
    if (e.key === 'Enter') {
      setMaterialJajeDescription(e.target.value + "\n");  //개행처리됨.
    }
  }
  //폼전송 엔트키 전송방지
  const checkKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  //입고버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData()
    formData.append('Id', props.materialInputListEditValue.Id)
    formData.append('ms_공장구분', props.materialInputListEditValue.ms_공장구분)
    formData.append('ms_입고출고구분',props.materialInputListEditValue.ms_입고출고구분)
    formData.append('ms_입출일자', moment(props.materialInputListEditValue.ms_입출일자).format('YYYY-MM-DD'))
    formData.append('ms_업체명', props.materialInputListEditValue.ms_업체명)
    formData.append('ms_업체코드', props.materialInputListEditValue.ms_업체코드)
    formData.append('ms_자재수불', props.materialInputListEditValue.ms_자재수불)
    formData.append('ms_계정과목코드',props.materialInputListEditValue.ms_계정과목코드)
    formData.append('ms_계정과목내용', props.materialInputListEditValue.ms_계정과목내용)
    formData.append('ms_자재코드', props.materialInputListEditValue.ms_자재코드)
    formData.append('ms_자재품번', props.materialInputListEditValue.ms_자재품번)
    formData.append('ms_자재규격', props.materialInputListEditValue.ms_자재규격)
    formData.append('ms_자재지출분류', props.materialInputListEditValue.ms_자재지출분류)
    formData.append('ms_단위량', props.materialInputListEditValue.ms_단위량)
    formData.append('ms_단위', props.materialInputListEditValue.ms_단위)
    formData.append('ms_자재단가', props.materialInputListEditValue.ms_자재단가)
    formData.append('ms_수량', props.materialInputListEditValue.ms_수량)
    formData.append('ms_금액', props.materialInputListEditValue.ms_금액)
    formData.append('ms_자재구분', props.materialInputListEditValue.ms_자재구분)
    formData.append('ms_세액', props.materialInputListEditValue.ms_세액)
    formData.append('ms_결재지급월', moment(materialJajeDateTime).format('YYYYMM'))
    formData.append('ms_결재지급금액', materialJajeIpgoGigubGumack)
    formData.append('ms_결재유무', materialGelje)
    formData.append('ms_결재지급일자', moment(materialJajeJigubDateTime).format('YYYY-MM-DD'))
    formData.append('ms_자재설명', materialJajeDescription)
    formData.append('ms_등록일자', moment(props.materialInputListEditValue.ms_등록일자).format('YYYY-MM-DD HH:mm'))
    formData.append('ms_등록자', props.urlpw)

    addOrEdit(formData)
    props.setMaterialInputListEditDbClickModal(false);
  }
  return (
    <div>
      <Dialog
      open={props.materialInputListEditDbClickModal}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={styleDialogTitle}>
          <ButtonGroup id="draggable-dialog-title" size="small">
            <Button color="danger" outline style={{ cursor: 'move', marginRight: '2px' }} size="small">
              이동
            </Button>
          </ButtonGroup>
          <Button color="danger" outline style={{ zIndex: '20' }} onClick={() => { props.setMaterialInputListEditDbClickModal(false) }} size="small">
            닫기
          </Button>
        </DialogTitle>
        <Form onSubmit={handleSubmit} onKeyDown={checkKeyDown}>
          <DialogContent className={`${MaterialInputListCoup.dialogContent}`} >
            <DialogContentText style={{ marginTop: 10, color: 'blue' }} >
              <h3>결재처리 내역</h3>
            </DialogContentText>
            <div>
              <TextField
                required
                variant="outlined"
                style={{ minWidth: 150, marginTop: '10px', float: 'center' }}
                size="small"
                label="지불월"
                type="month"
                format="yyyy-MM"
                value={moment(materialJajeDateTime).format('YYYY-MM')}
                InputLabelProps={{ shrink: true, }}
              onChange={materialJajeDateTimeHandle}
              />        
            </div>
            <div>
              <TextField
                required //필수등록
                style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                variant="outlined"
                InputLabelProps={
                  materialJajeIpgoGigubGumack === '' ? { shrink: false } : { shrink: true }
                }
                label="지급액"
                name="materialJajeIpgoGigubGumack"
                size="small"
              value={materialJajeIpgoGigubGumack ? materialJajeIpgoGigubGumack : ''}
              onChange={materialJajeIpgoGigubGumackHandle}
              />
              <TextField
                disabled
                // required //필수등록
                style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                variant="outlined"
                InputLabelProps={
                  materialJajeIpgoGumackQuantity === '' ? { shrink: false } : { shrink: true }
                }
                label="세금계산서접수[확인]"
                name="materialJajeIpgoGigubGumack"
                size="small"
                value={materialJajeIpgoGumackQuantity ? materialJajeIpgoGumackQuantity : ''}
              />
              <IconButton
                onClick={materialJajeGuljaPlusHandle}
                style={{ padding: '8px 0px 0px 0px' }} >
                <AddBoxIcon style={{ fontSize: 38, color: 'green' }} />
              </IconButton>
              <IconButton
                onClick={materialJajeGuljaMinusHandle}
                style={{ padding: '8px 0px 0px 0px' }} >
                <IndeterminateCheckBoxIcon style={{ fontSize: 38, color: 'green' }} />
              </IconButton>
            </div>
            <div>
              <FormControl
                required //필수등록
                variant="outlined"
                style={{ minWidth: 150, float: 'center', marginTop: '10px', marginBottom: '8px', marginRight: '2px' }}
                size="small"
              >
                <InputLabel>결재</InputLabel>
                <Select
                  required //필수등록
                  variant="outlined"
                  value={materialGelje ? materialGelje : ''}
                  onChange={materialGeljeHandleHandle}
                  label="결재"
                >
                  {/* <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem> */}
                  <MenuItem value={'미결'}>미결</MenuItem>
                  <MenuItem value={'즉시'}>즉시</MenuItem>
                  <MenuItem value={'결재'}>결재</MenuItem>
                  <MenuItem value={'보류'}>보류</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <TextField
                required
                variant="outlined"
                style={{ minWidth: 220, marginTop: '10px', float: 'center', }}
                size="small"
                label="결재지급일자"
                type="date"
                format="yyyyMMdd"
                value={moment(materialJajeJigubDateTime).format('YYYY-MM-DD')}
                InputLabelProps={{ shrink: true, }}
              onChange={materialJajeJigubDateTimeHandle}
              />
            </div>
            <div>
              <TextField
                style={{ width: 300, marginTop: '10px' }}
                label="Discription[기타기록]"
                placeholder="기타 기록하기"
                multiline
                variant="outlined"
                value={materialJajeDescription}
                InputLabelProps={{ shrink: true, }}
              onChange={materialJajeDescriptionHandle}
              onKeyDown={materialJajeDescriptionKeyDownHandle}
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <MuiButton
                type="submit"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{
                  height: '37px',
                  background: '#388e3c',
                  color: 'white',
                  width: 100,
                  marginRight: '2px',
                  float: 'center',
                }}
              >
                수정
              </MuiButton>
              <MuiButton
                onClick={() => {
                  props.setMaterialInputListEditDbClickModal(false);
                }}
                variant="contained"
                startIcon={<CloseIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                나가기
              </MuiButton>
            </div>
          </DialogContent>
          </Form>
      </Dialog>
    </div >
  )
}

export default MaterialInputListEditDbClick
